import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * @deprecated use `useSearchParams` from `react-router-dom` instead
 */
const useURLParams = () => {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return params;
};

export default useURLParams;
